import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Google / email-confirm come back with ?code= on whatever URL Supabase was
 * allowed to use. If that is "/" or "/practice", the usual redirects would
 * drop the query string and leave the user on a signed-out practice page.
 */
const OAuthCodeGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  if (location.pathname === '/welcome') return <>{children}</>;

  const search = new URLSearchParams(location.search);
  const hasCallback =
    search.has('code') ||
    search.has('error') ||
    search.has('error_description') ||
    location.hash.includes('access_token');

  if (hasCallback) {
    return <Navigate to={`/welcome${location.search}${location.hash}`} replace />;
  }

  return <>{children}</>;
};

export default OAuthCodeGate;
